import { render, staticRenderFns } from "./SectionEdit.vue?vue&type=template&id=ecac4078&scoped=true&"
import script from "./SectionEdit.vue?vue&type=script&lang=js&"
export * from "./SectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./SectionEdit.vue?vue&type=style&index=0&id=ecac4078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecac4078",
  null
  
)

export default component.exports